import { render, staticRenderFns } from "./ro.vue?vue&type=template&id=0b782476&scoped=true"
import script from "./ro.vue?vue&type=script&lang=js"
export * from "./ro.vue?vue&type=script&lang=js"
import style0 from "./ro.vue?vue&type=style&index=0&id=0b782476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b782476",
  null
  
)

export default component.exports